import React from 'react';

import {
  CONTRACT_COPY_OF_INSPECTION,
  CONTRACT_INSPECTION_CONTINGENCY,
  CONTRACT_INSPECTION_PRESENCE_OPTION,
  CONTRACT_INSPECTION_TYPE,
} from '@/config/constants';
import { ClauseText } from './Components/ContractText';
import AdditionalInspection from './Components/HomeInspection/AdditionalInspection';
import GeneralInspection from './Components/HomeInspection/generalinspection';
import NoInspection from './Components/HomeInspection/NoInspection';

interface Props {
  homeinspectionNegotiationDays?: number;
  inspectionContingency?: CONTRACT_INSPECTION_CONTINGENCY;
  inspectionType?: CONTRACT_INSPECTION_TYPE;
  additionalInspectionType?: string[];
  copyOfInspection?: CONTRACT_COPY_OF_INSPECTION;
  presenceOption?: CONTRACT_INSPECTION_PRESENCE_OPTION;
  enableBuyerNegotiateReleaseDays?: boolean;
  buyerNegotiateReleaseDays?: number;
  enableBuyerNegotiateCreditsPriceDays?: boolean;
  buyerNegotiateCreditsPriceDays?: number;
  enableBuyerNegotiateCreditsCostsDays?: boolean;
  buyerNegotiateCreditsCostsDays?: number;
}

const HomeInspection = ({
  homeinspectionNegotiationDays,
  inspectionContingency,
  inspectionType,
  additionalInspectionType,
  copyOfInspection,
  presenceOption,
  enableBuyerNegotiateReleaseDays,
  buyerNegotiateReleaseDays,
  enableBuyerNegotiateCreditsPriceDays,
  buyerNegotiateCreditsPriceDays,
  enableBuyerNegotiateCreditsCostsDays,
  buyerNegotiateCreditsCostsDays,
}: Props) => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Home Inspection Contingency
      </h2>
      {inspectionType !== CONTRACT_INSPECTION_TYPE.NOT_SELECTED &&
        inspectionContingency &&
        inspectionContingency !==
          CONTRACT_INSPECTION_CONTINGENCY.NOT_SELECTED && (
          <p className="ml-4 mb-3">
            <strong>Post-Inspection Negotiation Rights:</strong>{' '}
            {inspectionContingency ===
            CONTRACT_INSPECTION_CONTINGENCY.RESERVE_THE_RIGHT
              ? 'Buyer reserves the right to negotiate price post inspection.'
              : inspectionContingency ===
                CONTRACT_INSPECTION_CONTINGENCY.WAIVE_THR_RIGHT
              ? 'Buyer waives the right to negotiate price post inspection.'
              : ''}
          </p>
        )}

      {inspectionType !== CONTRACT_INSPECTION_TYPE.NOT_SELECTED && (
        <div className="ml-4 mb-3">
          {copyOfInspection ===
          CONTRACT_COPY_OF_INSPECTION.PROVIDE_FULL_COPY ? (
            <p>
              <strong>Inspection Copy:</strong> Buyer to provide a full copy of
              inspection to seller.
            </p>
          ) : copyOfInspection ===
            CONTRACT_COPY_OF_INSPECTION.WITHHOLD_FULL_COPY ? (
            <p>
              <strong>Inspection Copy:</strong> Buyer reserves right to withhold
              full copy of inspection from seller.
            </p>
          ) : null}

          {presenceOption === CONTRACT_INSPECTION_PRESENCE_OPTION.BE_PRESENT ? (
            <p>
              <strong>Inspection Presence:</strong> Buyer to be present at time
              of inspection.
            </p>
          ) : presenceOption ===
            CONTRACT_INSPECTION_PRESENCE_OPTION.WAIVE_RIGHT ? (
            <p>
              <strong>Inspection Presence:</strong> Buyer waives right to be
              present at time of inspection.
            </p>
          ) : null}

          {(enableBuyerNegotiateReleaseDays ||
            enableBuyerNegotiateCreditsPriceDays ||
            enableBuyerNegotiateCreditsCostsDays) && (
            <p>
              <strong>Negotiation Rights Timeline:</strong>{' '}
              {enableBuyerNegotiateReleaseDays
                ? `Release of contract up to ${
                    buyerNegotiateReleaseDays ?? 0
                  } days. `
                : ''}
              {enableBuyerNegotiateCreditsPriceDays
                ? `Credits to price up to ${
                    buyerNegotiateCreditsPriceDays ?? 0
                  } days. `
                : ''}
              {enableBuyerNegotiateCreditsCostsDays
                ? `Credits to costs up to ${
                    buyerNegotiateCreditsCostsDays ?? 0
                  } days. `
                : ''}
            </p>
          )}
        </div>
      )}
      {inspectionType === CONTRACT_INSPECTION_TYPE.GENERAL_INSPECTION ? (
        <>
          <GeneralInspection
            homeinspectionNegotiationDays={homeinspectionNegotiationDays}
          />
        </>
      ) : inspectionType === CONTRACT_INSPECTION_TYPE.ADDITIONAL_INSPECTION ? (
        <>
          <GeneralInspection
            homeinspectionNegotiationDays={homeinspectionNegotiationDays}
          />
          <AdditionalInspection
            additionalInspectionType={additionalInspectionType}
            homeinspectionNegotiationDays={homeinspectionNegotiationDays}
          />
        </>
      ) : (
        <>
          <NoInspection />
        </>
      )}
    </div>
  );
};

export default HomeInspection;
